import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';

import {ParametrizacaoImpedimentoComponent} from './parametrizacao-impedimento/parametrizacao-impedimento.component';


const routes: Routes = [

  {
    path: 'parametrizacao',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],

    children:[
        
        {
          path: 'limite-cadin',
          component: ParametrizacaoImpedimentoComponent,
          data: { canReuse: false}
        }
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ParametrizacaoRoutingModule { }
